import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { EmptyState } from "@/components/app/lists/empty-state";
import { PageHeader } from "@/components/app/shell/page-header";
import { ReadFailed } from "@/components/app/lists/read-failed";
import { Skeleton } from "@/components/ui/skeleton";
import { orpc } from "@/lib/orpc";
import { MoveInTodo } from "@/components/app/portal/move-in-todo";
import { useMoveIns } from "@/components/app/portal/use-move-ins";

export const Route = createFileRoute("/family-portal/move-in/$moveInId")({
  head: () => ({ meta: [{ title: "Move-in | People AI" }] }),
  component: FamilyMoveIn,
});

/** A move-in from the family's side: what the community asks of them, done right here. */
function FamilyMoveIn() {
  const { moveInId } = Route.useParams();
  const mine = useMoveIns();
  const todos = useQuery({
    ...orpc.portal.moveIns.todos.queryOptions({ input: { moveInId } }),
    retry: false,
  });
  const moveIn = mine.data?.find((row) => row.moveInId === moveInId);
  const name = moveIn ? `${moveIn.firstName} ${moveIn.lastName}`.trim() : "Moving in";

  return (
    <div className="max-w-2xl space-y-6">
      <PageHeader
        title={name}
        meta={[moveIn?.facilityName, moveIn?.facilityPhone].filter(Boolean).join(", ")}
      />
      {todos.isError ? (
        <ReadFailed
          message="Could not load this move-in."
          error={todos.error}
          onRetry={() => void todos.refetch()}
          retrying={todos.isFetching}
        />
      ) : todos.isPending ? (
        <Skeleton className="h-32 w-full rounded-xl" />
      ) : todos.data.length === 0 ? (
        <EmptyState
          title="Nothing to do yet"
          description="When the community needs something from you, it will appear here."
        />
      ) : (
        <div className="space-y-3">
          {todos.data.map((todo) => (
            <MoveInTodo key={todo.id} todo={todo} />
          ))}
        </div>
      )}
    </div>
  );
}
